import { AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { Title} from "@angular/platform-browser";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { DynamicBarService} from "../../../_components/dynamic-bar/dynamic-bar.service";
import { ActivatedRoute, Router} from "@angular/router";
import { Periodo} from "../../../_models/interfaces";
import { NavBarObject} from "../../../_components/nav-bar/config";
import { NivelacionesService} from "../_services/nivelaciones.service";

const MOCKDATA = [
    {curso: 'Kinder A', nivelaciones: {ausentes: 1, retardos: 0, asistencias: 12, citados: 14}},
    {curso: 'Kinder B', nivelaciones: {ausentes: 0, retardos: 1, asistencias: 6, citados: 21}},
    {curso: '1 A', nivelaciones: {ausentes: 0, retardos: 0, asistencias: 0, citados: 3}},
    {curso: '1 B', nivelaciones: {ausentes: 4, retardos: 2, asistencias: 3, citados: 6}},
    {curso: '2 A', nivelaciones: {ausentes: 1, retardos: 3, asistencias: 5, citados: 18}},
    {curso: '2 B', nivelaciones: {ausentes: 0, retardos: 0, asistencias: 6, citados: 5}},
    {curso: '3 A', nivelaciones: {ausentes: 3, retardos: 6, asistencias: 0, citados: 3}},
    {curso: '3 B', nivelaciones: {ausentes: 0, retardos: 1, asistencias: 1, citados: 2}},
    {curso: '4 A', nivelaciones: {ausentes: 0, retardos: 1, asistencias: 7, citados: 2}},
    {curso: '4 B', nivelaciones: {ausentes: 0, retardos: 0, asistencias: 2, citados: 9}},
    {curso: '5 A', nivelaciones: {ausentes: 2, retardos: 0, asistencias: 2, citados: 10}},
    {curso: '5 B', nivelaciones: {ausentes: 1, retardos: 0, asistencias: 12, citados: 14}},
    {curso: '6 A', nivelaciones: {ausentes: 1, retardos: 0, asistencias: 12, citados: 14}},
    {curso: '6 B', nivelaciones: {ausentes: 1, retardos: 0, asistencias: 12, citados: 14}},
    {curso: '7 A', nivelaciones: {ausentes: 1, retardos: 0, asistencias: 12, citados: 14}},
    {curso: '7 B', nivelaciones: {ausentes: 1, retardos: 0, asistencias: 12, citados: 14}}
];

@Component({
    selector: 'nivelaciones-directivo',
    standalone: false,
    templateUrl: 'nivelaciones-directivo.component.html',
    styleUrls: ['../citacion-materia-curso/citacion-materia-curso.component.scss', './nivelaciones-directivo.component.scss',
    '../../estudio/materias-familia/materia-unidades/materia-unidades.component.scss'],
    host: {
        "(click)": "offClick($event)"
    }
})

export class NivelacionesDirectivoComponent implements OnInit, AfterViewInit {


    dataSource: MatTableDataSource<any>;
    displayedColumns = ['Curso', 'Registros', 'Porcentaje', 'Vinculos'];
    @ViewChild(MatSort, { static: false }) sort: MatSort;

    periodosNavBar;
    periodoSeleccionado: string | number = 0;

    constructor(private titleService: Title,
                private dynamicBarService: DynamicBarService,
                private nivelacionesService: NivelacionesService,
                private route: ActivatedRoute,
                private router: Router,
                private elRef: ElementRef) {
    }

    ngOnInit() {
        this.periodoSeleccionado = this.route.snapshot.paramMap.get('idPeriodo');

        this.route.parent.data.subscribe((data: { periodos: Periodo[] }) => {
            const periodo = data.periodos[0];
            this.periodosNavBar = [new NavBarObject(
                periodo.nombre,
                [`/nivelaciones/reportes/directivo/periodo/${periodo.id}`],
                periodo.id,
                [new NavBarObject('Acumulado', [`/nivelaciones/reportes/directivo/periodo/${periodo.id}`], periodo.id)].concat(
                    periodo.periodos.map((child, i) => {
                        if(!this.periodoSeleccionado && periodo.periodos.length - 1 == i){
                            this.periodoSeleccionado = child.id;
                        }
                        if (child.tipo < 2) {
                            return new NavBarObject(`Periodo ${child.nombre}`, [`/nivelaciones/reportes/directivo/periodo/${child.id}`], child.id)
                        } else {
                            return false;
                        }
                    }))
            )];
        });



        this.nivelacionesService.getNivelacionesDirectivo(this.periodoSeleccionado).subscribe(res => {
            this.dataSource = new MatTableDataSource<any>(res);
        });

        this.titleService.setTitle('Directivo - Nivelaciones');
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngAfterViewInit() {
        this.dynamicBarService.setBarra('nivelaciones-barra');
    }

    toggleDetalles(detalleElement){
        let els = this.elRef.nativeElement.querySelectorAll('.detalle'),
            control = detalleElement.hidden;
        els.forEach(el => {
            el.hidden = true;
        });
        if(control){
            detalleElement.hidden = !detalleElement.hidden;
        }
    }

    offClick(evt){
        if (!evt.target.classList.contains('circulo') && !evt.target.classList.contains('detalle') && !evt.target.classList.contains('detalle-lista') && !evt.target.classList.contains('detalle-item')) {
            let els = Array.prototype.slice.call(this.elRef.nativeElement.querySelectorAll('.detalle')),
                shownEl = els.filter(el => el.hidden == false);
            if(shownEl.length == 1){
                shownEl[0].hidden = true;
            }
        }
    }
}
